<template>
  <header class="header" :class="{'builder-true': isBuilder}">
    <div class="container container-header">
      <a class="header-logo-link" href="/">
        <img class="header-logo" src="../assets/img/logo.880c9773.svg" alt="">
        <span class="header-text">Funnels.com</span>
      </a>
      <!-- <router-link v-if="!showBookBtn" class="btn btn-primary btn-sm" to="/calcom">
        Book a time
      </router-link> -->
    </div>
  </header>
</template>

<script>

export default {
  name: "HeaderComponent",
  props: ['isBuilder'],
   data() {
    return {
      showBookBtn: true
    }
  },
  mounted() {
    console.log('PROPS', this.isBuilder)
  },
  watch: {
    $route: function() {
      this.showBookBtn = this.$route.path.includes('calcom');
    }
  },
}
</script>

<style lang="scss">
.header {
  height: 70px;
  flex-shrink: 0;

  background: linear-gradient(to bottom, #fff, rgb(228, 228, 228));
  display: flex;
  align-items: center;
  transition: all .3s;

  & .container-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all .3s;
  }

  &-close {
    display: none;
    width: 20px;
    height: 20px;
    // border: 1px solid red;
    position: relative;

    &::before, &::after {
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      background: rgba(0, 0, 0, 0.5);

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  &-logo-link {
    display: flex;
    justify-content: center;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.7);
  }

  &-logo {
    width: 30px;
    margin-right: 10px;
    transition: all .3s;
  }
  &-text {
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    font-weight: 700;
    font-size: 32px;
    transition: all .3s;
  }

  &.builder-true {
    height: 40px;
    position: relative;
    z-index: -1;
    & .container-header {
      width: 100%;
      max-width: initial;
      margin: 0;
    }
    .header-close {
      display: inline-block;
    }
    .header-logo {
    width: 12px;
    margin-right: 5px;
    }
    .header-text {
      font-size: 14px;
    }
  }
}
</style>